(function () {
  function initProduct(root) {
    if (!(root instanceof HTMLElement)) return;

    /* ---- Gallery ---- */
    const mediaItems = Array.from(root.querySelectorAll("[data-pp-media]"));
    const mainImg = root.querySelector("[data-pp-main-img]");
    const thumbs = Array.from(root.querySelectorAll("[data-pp-thumb]"));
    let current = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.classList.contains("is-active");
    }));

    function scrollThumbIntoView(thumb) {
      const strip = thumb?.closest(".parans-product__thumbs");
      if (!strip) return;
      const left = Math.max(
        0,
        Math.min(
          thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2,
          strip.scrollWidth - strip.clientWidth
        )
      );
      if (Math.abs(left - strip.scrollLeft) > 1) {
        if (typeof strip.scrollTo === "function") strip.scrollTo({ left: left, behavior: "smooth" });
        else strip.scrollLeft = left;
      }
    }

    function stopMedia(item) {
      if (!item) return;
      item.querySelectorAll("video").forEach(function (video) {
        try { video.pause(); } catch (error) {}
      });
      item.querySelectorAll("iframe").forEach(function (frame) {
        try {
          frame.contentWindow?.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: [] }), "*");
          frame.contentWindow?.postMessage({ method: "pause" }, "*");
        } catch (error) {}
      });
    }

    function showMedia(index) {
      if (!thumbs.length || !mediaItems.length) return;
      current = (index + thumbs.length) % thumbs.length;
      const t = thumbs[current];
      mediaItems.forEach(function (item, i) {
        if (i !== current) stopMedia(item);
        item.hidden = i !== current;
        item.classList.toggle("is-active", i === current);
      });
      thumbs.forEach((el, i) => el.classList.toggle("is-active", i === current));
      scrollThumbIntoView(t);
    }

    thumbs.forEach((t, i) => t.addEventListener("click", () => showMedia(i)));

    const prev = root.querySelector("[data-pp-prev]");
    const next = root.querySelector("[data-pp-next]");
    if (prev) prev.addEventListener("click", () => showMedia(current - 1));
    if (next) next.addEventListener("click", () => showMedia(current + 1));
    if (thumbs.length) showMedia(current);

    /* ---- Wishlist (visual toggle) ---- */
    const wish = root.querySelector("[data-pp-wishlist]");
    if (wish) {
      wish.addEventListener("click", function () {
        const on = wish.getAttribute("aria-pressed") === "true";
        wish.setAttribute("aria-pressed", on ? "false" : "true");
      });
    }

    /* ---- Ajax cart drawer ---- */
    const productForm = root.querySelector("form.parans-product__form");
    if (productForm && !productForm.dataset.ppAjaxCart) {
      productForm.dataset.ppAjaxCart = "1";

      function activateValidation() {
        productForm.classList.add("is-validating");
      }

      const inlineAtc = productForm.querySelector("[data-pp-inline-atc]");
      if (inlineAtc) {
        function keepInlineAtcInteractive() {
          if (inlineAtc.style.getPropertyValue("pointer-events") === "none") {
            inlineAtc.style.setProperty("pointer-events", "auto", "important");
          }
        }
        keepInlineAtcInteractive();
        new MutationObserver(keepInlineAtcInteractive).observe(inlineAtc, {
          attributes: true,
          attributeFilter: ["style"],
        });
      }

      const safeOptionControls = [
        ".pp-ymqdd__field",
        "[data-pp-qty-dec]",
        "[data-pp-qty-inc]",
        "[data-pp-tier-qty]",
      ].join(",");

      function keepSafeOptionControlsInteractive() {
        productForm.querySelectorAll(safeOptionControls).forEach(function (control) {
          if (control.disabled || control.getAttribute("aria-disabled") === "true") return;

          if (window.getComputedStyle(control).pointerEvents === "none") {
            control.style.setProperty("pointer-events", "auto", "important");
          }

          var wrapper = control.parentElement;
          if (!wrapper || wrapper.tagName !== "SPAN") return;

          wrapper.classList.add("pp-control-proxy");
          if (control.matches("[data-pp-qty-dec],[data-pp-qty-inc]")) wrapper.classList.add("pp-control-proxy--qty");
          if (control.matches("[data-pp-tier-qty]")) wrapper.classList.add("pp-control-proxy--tier");
          if (control.matches(".pp-ymqdd__field")) wrapper.classList.add("pp-control-proxy--dropdown");
          wrapper.style.setProperty("pointer-events", "auto", "important");
        });
      }

      keepSafeOptionControlsInteractive();
      new MutationObserver(keepSafeOptionControlsInteractive).observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "disabled", "aria-disabled"],
      });

      productForm.addEventListener("submit", activateValidation, true);
      productForm.addEventListener("click", function (event) {
        const proxy = event.target.closest("[data-pp-inline-atc]");
        if (!proxy) return;
        event.preventDefault();
        if (proxy.getAttribute("aria-disabled") === "true") return;
        activateValidation();
        const realButton = root.querySelector("button[name='add']");
        if (realButton && !realButton.disabled) realButton.click();
      });

      productForm.addEventListener("keydown", function (event) {
        const proxy = event.target.closest("[data-pp-inline-atc]");
        if (!proxy || (event.key !== "Enter" && event.key !== " ")) return;
        event.preventDefault();
        proxy.click();
      });

      productForm.addEventListener("change", function (event) {
        if (productForm.classList.contains("is-validating") || !event.target.closest("ymq-option")) return;
        window.setTimeout(function () {
          productForm.querySelectorAll(".ymq-option-box-error").forEach(function (box) {
            box.classList.remove("ymq-option-box-error");
          });
          productForm.querySelectorAll(".ymq-option-error").forEach(function (message) {
            message.innerHTML = "";
          });
        }, 0);
      }, true);

      function waitForCart(delay) {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delay);
        });
      }

      function drawerSectionsMatchCart(sections, cart) {
        if (!sections || typeof sections["cart-drawer"] !== "string" || !cart) return false;
        const documentFragment = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
        const drawer = documentFragment.querySelector("#Cart-Drawer, cart-drawer");
        if (!drawer) return false;

        const renderedRows = drawer.querySelectorAll("#CartDrawer-CartItems .cart-item").length;
        const renderedCount = parseInt(
          drawer.querySelector("[data-cart-text]")?.textContent || "",
          10
        );
        const expectedRows = Array.isArray(cart.items) ? cart.items.length : 0;
        const emptyState = drawer.classList.contains("is-empty") || !!drawer.querySelector(".drawer__inner-empty");

        if (cart.item_count > 0) {
          return !emptyState &&
            renderedRows === expectedRows &&
            (!Number.isFinite(renderedCount) || renderedCount === cart.item_count);
        }
        return emptyState && renderedRows === 0;
      }

      async function fetchConsistentDrawerSections(sectionIds) {
        const retryDelays = [0, 120, 250, 500, 900];
        let latestSections = null;

        for (const delay of retryDelays) {
          if (delay) await waitForCart(delay);
          const cacheKey = Date.now() + "-" + Math.random().toString(16).slice(2);
          const responses = await Promise.all([
            fetch("/cart.js?_=" + cacheKey, {
              headers: { "Accept": "application/json" },
              credentials: "same-origin",
              cache: "no-store"
            }),
            fetch(
              (window.routes && window.routes.cart_update_url) || "/cart/update.js",
              {
                method: "POST",
                headers: { "Accept": "application/json", "Content-Type": "application/json" },
                credentials: "same-origin",
                cache: "no-store",
                body: JSON.stringify({
                  updates: {},
                  sections: sectionIds,
                  sections_url: window.location.pathname
                })
              }
            )
          ]);
          if (!responses[0].ok || !responses[1].ok) continue;

          const results = await Promise.all([responses[0].json(), responses[1].json()]);
          latestSections = results[1].sections || results[1];
          if (drawerSectionsMatchCart(latestSections, results[0])) return latestSections;
        }

        return latestSections;
      }

      productForm.addEventListener("submit", function (event) {
        const isYmqForm = !!productForm.querySelector("ymq-option");
        const cartDrawer = document.querySelector("cart-drawer");
        if (!cartDrawer || typeof cartDrawer.renderContents !== "function") return;
        if (event.defaultPrevented) return;
        event.preventDefault();
        const submitter = event.submitter || productForm.querySelector('button[name="add"], button[type="submit"]');
        if (submitter && submitter.disabled) return;
        const formData = new FormData(productForm);
        const drawerSectionIds = typeof cartDrawer.getSectionsToRender === "function"
          ? cartDrawer.getSectionsToRender().map(function (section) { return section.id; })
          : [];
        if (typeof cartDrawer.getSectionsToRender === "function") {
          formData.append("sections", drawerSectionIds.join(","));
          formData.append("sections_url", window.location.pathname);
        }
        if (submitter) submitter.setAttribute("aria-busy", "true");
        const action = productForm.getAttribute("action") || (window.routes && window.routes.cart_add_url) || "/cart/add";
        fetch(action, {
          method: "POST",
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (parsed) {
              if (!response.ok || parsed.status) throw parsed;
              return parsed;
            });
          })
          .then(async function (parsed) {
            if (drawerSectionIds.length) {
              try {
                const freshSections = await fetchConsistentDrawerSections(drawerSectionIds);
                if (freshSections && typeof freshSections === "object") parsed.sections = freshSections;
              } catch (error) {
                console.warn("Parans cart drawer refresh used add response", error);
              }
            }
            if (submitter && typeof cartDrawer.setActiveElement === "function") cartDrawer.setActiveElement(submitter);
            cartDrawer.renderContents(parsed);
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: parsed }));
            productForm.classList.remove("is-validating");
          })
          .catch(function (error) {
            console.error("Parans ajax cart failed", error);
            // YMQ has already validated and populated this form. A native
            // fallback would bypass its lifecycle and redirect to /cart.
            if (!isYmqForm) productForm.submit();
          })
          .finally(function () {
            if (submitter) submitter.removeAttribute("aria-busy");
          });
      });
    }

    /* ---- Print segmented toggle ---- */
    root.querySelectorAll("[data-pp-segmented]").forEach(function (group) {
      const hidden = group.querySelector("[data-pp-seg-input]");
      const segs = Array.from(group.querySelectorAll("[data-pp-seg]"));
      segs.forEach(function (seg) {
        seg.addEventListener("click", function () {
          segs.forEach((s) => s.classList.remove("is-active"));
          seg.classList.add("is-active");
          if (hidden) hidden.value = seg.getAttribute("data-value") || seg.textContent.trim();
        });
      });
    });

    /* ---- Accessory grid ---- */
    root.querySelectorAll("[data-pp-accessory-grid]").forEach(function (grid) {
      const hidden = grid.parentElement.querySelector("[data-pp-accessory-input]");
      const items = Array.from(grid.querySelectorAll("[data-pp-accessory]"));
      items.forEach(function (item) {
        item.addEventListener("click", function () {
          items.forEach((s) => s.classList.remove("is-active"));
          item.classList.add("is-active");
          item.setAttribute("aria-pressed", "true");
          if (hidden) hidden.value = item.getAttribute("data-value") || "";
        });
      });
    });

    /* ---- Quantity stepper ---- */
    root.querySelectorAll("[data-pp-qty]").forEach(function (qty) {
      const input = qty.querySelector("input");
      const dec = qty.querySelector("[data-pp-qty-dec]");
      const inc = qty.querySelector("[data-pp-qty-inc]");
      function clamp() {
        let v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
      }
      if (dec) dec.addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      if (input) input.addEventListener("change", clamp);
    });

    /* ---- Real-time tier price calculator ---- */
    (function () {
      const tiersEl = root.querySelector("[data-pp-tiers]");
      let tiers = [{ q: 1, d: 0 }];
      try { tiers = JSON.parse(tiersEl.textContent.trim()); } catch (e) {}
      tiers.sort(function (a, b) { return a.q - b.q; });
      // base 改为动态读取:自建变体选择器切尺寸时会更新 data-pp-base,这里实时取最新值
      function getBase() { return parseInt(root.getAttribute("data-pp-base"), 10) || 0; }
      function readMoneyCents(el) {
        if (!el) return 0;
        var raw = el.getAttribute("data-ymq-money") || el.textContent || "";
        var n = parseFloat(String(raw).replace(/[^\d.-]/g, ""));
        return isNaN(n) ? 0 : Math.round(n * 100);
      }
      function getYmqAddonCents() {
        var total = 0;
        root.querySelectorAll("ymq-option .ymq-options-box").forEach(function (box) {
          var r = box.getBoundingClientRect();
          if (r.width <= 0 || r.height <= 0) return;
          var item = null;
          var checked = box.querySelector(".ymq-option-button-input:checked, input[type='radio']:checked, input[type='checkbox']:checked");
          if (checked) item = checked.closest(".ymq-option-value-item");
          if (!item) {
            var selected = (box.querySelector(".pp-ymqdd__text")?.textContent || "").trim();
            if (selected) {
              Array.prototype.some.call(box.querySelectorAll(".ymq-option-value-item"), function (candidate) {
                var input = candidate.querySelector("input");
                var value = (input?.value || candidate.querySelector(".ymq-option-value")?.textContent || "").trim();
                if (value === selected) { item = candidate; return true; }
                return false;
              });
            }
          }
          if (!item) return;
          total += readMoneyCents(item.querySelector(".ymq-price-span[data-ymq-money], .ymq-option-sale-price, .ymq-option-price-info, .ymq-option-value-price"));
        });
        return total;
      }
      const qtyInput = root.querySelector("[data-pp-qty] input") || root.querySelector("input[name='quantity']");
      const unitEl = root.querySelector("[data-pp-unit]");
      const origEl = root.querySelector("[data-pp-orig]");
      const ymqPriceProbe = root.querySelector("[data-pp-ymq-price-probe]");
      var ymqRegularUnit = 0;
      var ymqProductFactor = 1;
      var ymqVariantPriceCache = new Map();

      function captureYmqRegularUnit() {
        if (!ymqPriceProbe) return false;
        var currentPriceEl = ymqPriceProbe.querySelector(".ymq-b2b-current-product-price");
        var priceEl = currentPriceEl?.querySelector(".ymq-b2b-price-span[data-ymq-money]")
          || currentPriceEl?.querySelector("[ymq-b2b-money]")
          || ymqPriceProbe.querySelector(".ymq-b2b-price-span[data-ymq-money]")
          || ymqPriceProbe.querySelector("[ymq-b2b-money]");
        var markerEl = currentPriceEl || priceEl?.closest("[ymq-b2b-variant-id]") || ymqPriceProbe.querySelector("[ymq-b2b-variant-id]");
        var markerVariantId = markerEl?.getAttribute("ymq-b2b-variant-id") || "";
        var currentVariantId = root.getAttribute("data-pp-variant-id") || "";
        // YMQ may leave the previous variant's price in the probe after the custom selector changes.
        if (markerVariantId && currentVariantId && markerVariantId !== currentVariantId) return false;
        var cents = readMoneyCents(priceEl || ymqPriceProbe);
        if (!cents) return false;
        var raw = priceEl?.getAttribute("data-ymq-money") || priceEl?.getAttribute("ymq-b2b-money") || "";
        var amount = parseFloat(String(raw).replace(/[^\d.-]/g, ""));
        var productBase = getBase();
        if (productBase > 0) {
          ymqProductFactor = !isNaN(amount) && amount > 0 ? amount * 100 / productBase : cents / productBase;
        }
        if (currentVariantId) ymqVariantPriceCache.set(currentVariantId, cents);
        var changed = cents !== ymqRegularUnit;
        ymqRegularUnit = cents;
        return changed;
      }

      if (ymqPriceProbe) {
        captureYmqRegularUnit();
        new MutationObserver(function () {
          if (captureYmqRegularUnit()) recompute();
        }).observe(ymqPriceProbe, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["data-ymq-money", "ymq-b2b-money", "ymq-b2b-variant-id"] });
      }
      let tierPills = Array.prototype.slice.call(root.querySelectorAll("[data-pp-tier-qty]"));
      function getUnitCopy() {
        var dataEl = root.querySelector("[data-pp-variant-data]");
        var dataText = dataEl ? dataEl.textContent || "" : "";
        var selectedText = root.querySelector("[data-pp-variant-options]")?.textContent || "";
        if (/\/products\/custom-cards(?:\/|$)/i.test(window.location.pathname)) return { tier: "set", per: "Per Set" };
        if (/\bSET\b/i.test(dataText + " " + selectedText)) return { tier: "set", per: "Per Set" };
        return null;
      }
      const unitCopy = getUnitCopy();
      var ymqTierKey = "";
      function getYmqDiscountBox() {
        return Array.prototype.slice.call(root.querySelectorAll("ymq-option .ymq-options-box")).filter(function (box) {
          var label = (box.querySelector(".ymq_lable")?.textContent || box.getAttribute("ymq-option-label") || "").trim();
          return box.getAttribute("ymq-option-type") === "19" || /^discounts?$/i.test(label);
        })[0] || null;
      }
      function readYmqDiscountTiers() {
        var box = getYmqDiscountBox();
        if (!box) return [];
        return Array.prototype.slice.call(box.querySelectorAll(".ymq-option-qb-item")).map(function (item) {
          var input = item.querySelector(".ymq-option-qb-input");
          var start = parseInt(item.querySelector(".ymq-option-quantity-range-start")?.textContent || input?.value, 10);
          var endText = item.querySelector(".ymq-option-quantity-range-end")?.textContent || input?.getAttribute("ymq-option-next-quantity") || "";
          var end = parseInt(endText, 10);
          var discount = parseFloat((item.querySelector(".ymq-option-qb-discount")?.textContent || "").replace(/[^\d.-]/g, ""));
          var price = readMoneyCents(item.querySelector(".ymq-price-span[data-ymq-money], .ymq-option-qb-price-unit .ymq-price-span"));
          if (isNaN(start) || isNaN(discount)) return null;
          return { q: start, end: isNaN(end) ? null : end, d: discount, price: price };
        }).filter(Boolean).sort(function (a, b) { return a.q - b.q; });
      }
      function getYmqB2bDiscountBox() {
        return document.querySelector(".ymq-b2b-qb-table-box");
      }
      function readYmqB2bDiscountTiers() {
        var box = getYmqB2bDiscountBox();
        if (!box) return [];
        return Array.prototype.slice.call(box.querySelectorAll("table.ymq-b2b-qb-table tbody tr")).map(function (row) {
          var cells = row.querySelectorAll("th, td");
          var start = parseInt(cells[0]?.textContent, 10);
          var discount = parseFloat((cells[1]?.textContent || "").replace(/[^\d.-]/g, ""));
          if (isNaN(start) || isNaN(discount)) return null;
          return { q: start, end: null, d: discount, price: 0 };
        }).filter(Boolean).sort(function (a, b) { return a.q - b.q; });
      }
      function hideYmqDiscountSource() {
        var box = getYmqDiscountBox();
        if (box) {
          box.setAttribute("data-pp-ymq-discount-source", "");
          box.style.display = "none";
        }
        var b2bBox = getYmqB2bDiscountBox();
        if (b2bBox) {
          b2bBox.setAttribute("data-pp-ymq-discount-source", "");
          b2bBox.style.display = "none";
        }
      }
      function renderTierPill(tier) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "parans-product__tier";
        button.setAttribute("data-pp-tier-qty", tier.q);
        button.setAttribute("data-pp-tier-d", tier.d);

        var buy = document.createElement("span");
        buy.className = "parans-product__tier-buy";
        buy.textContent = "Buy: " + tier.q + " +";

        var price = document.createElement("span");
        price.className = "parans-product__tier-price";
        var priceValue = document.createElement("b");
        priceValue.setAttribute("data-pp-tier-unit", "");
        setMoneyText(priceValue, tier.price ? tier.price : Math.round(getBase() * (1 - tier.d / 100)));
        price.appendChild(priceValue);
        price.appendChild(document.createTextNode(" / Each"));

        var save = document.createElement("span");
        save.className = "parans-product__tier-save";
        save.textContent = "SAVE " + tier.d + "%";

        button.appendChild(buy);
        button.appendChild(price);
        button.appendChild(save);
        return button;
      }
      function bindTierPillClicks() {
        tierPills.forEach(function (pill) {
          if (pill.dataset.ppTierBound) return;
          pill.dataset.ppTierBound = "1";
          pill.addEventListener("click", function () {
            qtyInput.value = pill.getAttribute("data-pp-tier-qty");
            qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
            recompute();
          });
        });
      }
      function syncYmqDiscountTiers() {
        var parsed = readYmqDiscountTiers();
        if (parsed.length < 2) parsed = readYmqB2bDiscountTiers();
        if (parsed.length < 2) return;
        hideYmqDiscountSource();
        var key = parsed.map(function (tier) { return [tier.q, tier.end || "", tier.d, tier.price || ""].join(":"); }).join("|");
        if (key === ymqTierKey) return;
        ymqTierKey = key;
        tiers = parsed.map(function (tier) { return { q: tier.q, d: tier.d }; });
        var tierbar = root.querySelector(".parans-product__tierbar");
        if (!tierbar) return;
        tierbar.querySelectorAll("[data-pp-tier-qty]").forEach(function (pill) {
          var wrapper = pill.parentElement;
          if (wrapper && wrapper.parentElement === tierbar && wrapper.tagName === "SPAN") wrapper.remove();
          else pill.remove();
        });
        tierbar.querySelectorAll(":scope > span:empty").forEach(function (wrapper) { wrapper.remove(); });
        parsed.forEach(function (tier) { tierbar.appendChild(renderTierPill(tier)); });
        tierPills = Array.prototype.slice.call(root.querySelectorAll("[data-pp-tier-qty]"));
        bindTierPillClicks();
      }
      function replaceTextNode(el, pattern, value) {
        if (!el) return;
        Array.prototype.forEach.call(el.childNodes, function (node) {
          if (node.nodeType === 3) node.textContent = node.textContent.replace(pattern, value);
        });
      }
      function syncUnitLabels() {
        if (!unitCopy) return;
        tierPills.forEach(function (pill) {
          replaceTextNode(pill.querySelector(".parans-product__tier-price"), /\/\s*Each/i, "/ " + unitCopy.tier);
        });
        document.querySelectorAll(".parans-product__perpiece").forEach(function (el) {
          replaceTextNode(el, /\/\s*Per Piece/i, "/ " + unitCopy.per);
        });
      }
      function money(c) { return "$" + (c / 100).toFixed(2); }
      function setMoneyText(el, cents) {
        if (!el) return;
        if (window.ParansMoney && typeof window.ParansMoney.applyUsdAmount === "function") {
          window.ParansMoney.applyUsdAmount(el, cents / 100);
          return;
        }
        el.setAttribute("htmoney", "");
        el.removeAttribute("data-ht-price-converted");
        el.removeAttribute("data-ht-price-converted-from");
        el.removeAttribute("data-ht-price-converted-to");
        el.textContent = money(cents);
      }
      // 更新「所有」匹配元素(主总额框 + 吸底购买条复用同一组 data 属性,一处算、处处同步)。
      // 用 document 范围:吸底条会被移到 body(脱离 main 缩放),仍要能同步到。PDP 单产品,不会误伤。
      function setAll(sel, cents) { document.querySelectorAll(sel).forEach(function (e) { setMoneyText(e, cents); }); }
      function hideAll(sel, hide) { document.querySelectorAll(sel).forEach(function (e) { e.hidden = hide; }); }
      function discountFor(q) { let d = 0; for (let i = 0; i < tiers.length; i++) { if (q >= tiers[i].q) d = tiers[i].d; } return d; }
      /* 0628用户:数量框只自适应「框内数字字号」,不动外框/按钮。
         用隐藏 span 量出数字真实宽度(input.scrollWidth 对溢出不可靠),超出输入框可用宽就逐步缩字号,
         直到完整显示;位数变少时还原 CSS 默认字号(响应式)。web+移动通用。 */
      var _qtyMeasure = null;
      function fitQtyFont(inp) {
        if (!inp) return;
        inp.style.fontSize = "";                       // 先还原 CSS 默认(响应式)
        var cs = getComputedStyle(inp);
        var base = parseFloat(cs.fontSize) || 22;
        var avail = inp.clientWidth - 6;               // 可用宽(留余量给内边距/光标)
        if (avail <= 0) return;
        if (!_qtyMeasure) {
          _qtyMeasure = document.createElement("span");
          _qtyMeasure.setAttribute("aria-hidden", "true");
          _qtyMeasure.style.cssText = "position:absolute;left:-9999px;top:-9999px;visibility:hidden;white-space:nowrap;pointer-events:none;";
          document.body.appendChild(_qtyMeasure);
        }
        _qtyMeasure.style.fontFamily = cs.fontFamily;
        _qtyMeasure.style.fontWeight = cs.fontWeight;
        _qtyMeasure.style.letterSpacing = cs.letterSpacing;
        _qtyMeasure.textContent = inp.value || "0";
        var size = base, guard = 0;
        _qtyMeasure.style.fontSize = size + "px";
        while (_qtyMeasure.offsetWidth > avail && size > 8 && guard++ < 40) {
          size -= 1;
          _qtyMeasure.style.fontSize = size + "px";
        }
        if (size < base) inp.style.fontSize = size + "px";
      }
      /* 0628用户:移动端吸底买区——总价区(Total+Save+单价)塞不下时整体等比缩小,
         三个数字一起变小但全部可见、不截断;ATC 原大固定在右。桌面不缩(Total 向左延伸)。 */
      function fitStickySummary() {
        var summary = document.querySelector(".parans-product__stickybuy .parans-product__total-summary");
        if (!summary) return;
        summary.style.transform = "";
        if (window.innerWidth > 749) return;
        var avail = summary.clientWidth;
        var content = summary.scrollWidth;
        if (content > avail + 1 && avail > 0) {
          var scale = avail / content;
          if (scale < 1) summary.style.transform = "scale(" + scale.toFixed(4) + ")";
        }
      }
      function recompute() {
        syncYmqDiscountTiers();
        captureYmqRegularUnit();
        const productBase = getBase();
        const addon = getYmqAddonCents();
        const base = productBase + addon;
        let q = parseInt(qtyInput.value, 10); if (isNaN(q) || q < 1) q = 1;
        const d = discountFor(q);
        const regularUnit = (ymqRegularUnit || productBase) + addon;
        // 数量阶梯继续作用于 YMQ 已折后的单价，例如 $2.31 × 64% = $1.48。
        const unit = d > 0 ? Math.round(regularUnit * (1 - d / 100)) : regularUnit;
        const total = unit * q;
        const save = base * q - total;
        const hasDiscount = unit < base;
        if (unitEl) { setMoneyText(unitEl, unit); unitEl.classList.toggle("is-discounted", hasDiscount); }
        if (origEl) { setMoneyText(origEl, base); origEl.hidden = !hasDiscount; }
        setAll("[data-pp-box-unit]", unit);
        setAll("[data-pp-box-total]", total);
        setAll("[data-pp-savebox-amt]", save);
        setAll("[data-pp-savebox-unit]", unit);
        hideAll("[data-pp-savebox]", save <= 0);
        // 阶梯 pills 与实际结算采用同一个“YMQ 优惠后单价”作为计算基数。
        tierPills.forEach(function (pill) {
          const pd = parseFloat(pill.getAttribute("data-pp-tier-d")) || 0;
          const pu = pill.querySelector("[data-pp-tier-unit]");
          if (pu) setMoneyText(pu, Math.round(regularUnit * (1 - pd / 100)));
        });
        syncUnitLabels();
        fitQtyFont(qtyInput);   // 数量改变后自适应框内数字字号
        fitStickySummary();     // 移动端总价区塞不下时整体等比缩小(Total/Save/单价全可见)
      }
      if (qtyInput) {
        qtyInput.addEventListener("input", recompute);
        qtyInput.addEventListener("change", recompute);
        root.querySelectorAll("[data-pp-qty-dec],[data-pp-qty-inc]").forEach(function (b) {
          b.addEventListener("click", function () { setTimeout(recompute, 0); });
        });
        bindTierPillClicks();
        // 自建变体选择器切尺寸后,base 已更新 → 重算总价/单价/阶梯
        root.addEventListener("pp:variant-change", function () {
          var variantId = root.getAttribute("data-pp-variant-id") || "";
          ymqRegularUnit = ymqVariantPriceCache.get(variantId)
            || Math.round(getBase() * ymqProductFactor)
            || getBase();
          recompute();
          [80, 250, 700, 1500].forEach(function (delay) {
            window.setTimeout(recompute, delay);
          });
        });
        root.addEventListener("change", function (e) {
          if (e.target?.closest && e.target.closest("ymq-option")) setTimeout(recompute, 0);
        }, true);
        document.addEventListener("click", function (e) {
          if (root.contains(e.target) && e.target?.closest && e.target.closest(".pp-ymqdd__opt,.ymq-option-value-item,.ymq-option-qb-item")) setTimeout(recompute, 0);
        }, true);
        recompute();
        setTimeout(recompute, 800);
        setTimeout(recompute, 1800);
        setTimeout(recompute, 3200);
        setTimeout(recompute, 5000);
      }
    })();

    /* ---- Upload Artwork:多图缩略图预览 + 删除 + 隐藏 input 供加购;并把首张上传图同步到大图&第一张缩略图 ---- */
    root.querySelectorAll("[data-pp-upload-field]").forEach(function (field) {
      const input = field.querySelector("[data-pp-upload-input]");
      const nameEl = field.querySelector("[data-pp-upload-name]");
      const previews = field.querySelector("[data-pp-upload-previews]");
      const hidden = field.querySelector("[data-pp-upload-hidden]");
      const propBase = field.getAttribute("data-pp-upload-prop") || "Upload Artwork";
      if (!input || !previews || !hidden) return;
      const original = nameEl ? nameEl.textContent : "";
      let files = [];

      /* 画廊原始态(删除后还原):大图 + 第一张缩略图 */
      const firstThumb = thumbs.find(function (thumb) {
        return thumb.getAttribute("data-media-type") === "image";
      });
      const firstImageIndex = Math.max(0, thumbs.indexOf(firstThumb));
      const origMain = mainImg ? mainImg.getAttribute("src") : null;
      const origThumbFull = firstThumb ? firstThumb.getAttribute("data-full") : null;
      const origThumbImg = firstThumb && firstThumb.querySelector("img") ? firstThumb.querySelector("img").getAttribute("src") : null;
      function urlFor(f) { if (!f.__url) { try { f.__url = URL.createObjectURL(f); } catch (e) { f.__url = ""; } } return f.__url; }

      function syncHidden() {
        hidden.innerHTML = "";
        files.forEach(function (f, i) {
          const hi = document.createElement("input");
          hi.type = "file";
          hi.name = "properties[" + propBase + (files.length > 1 ? " " + (i + 1) : "") + "]";
          try { const dt = new DataTransfer(); dt.items.add(f); hi.files = dt.files; } catch (e) {}
          hidden.appendChild(hi);
        });
      }
      function syncGallery() {
        const firstImg = files.filter(function (f) { return /^image\//.test(f.type); })[0];
        if (firstImg) {
          const url = urlFor(firstImg);
          if (mainImg && url) mainImg.src = url;
          if (firstThumb && url) {
            firstThumb.setAttribute("data-full", url);
            const ti = firstThumb.querySelector("img");
            if (ti) { ti.loading = "eager"; ti.removeAttribute("loading"); ti.src = url; }   /* 去掉 lazy:移动端缩略图在视口外,懒加载会不显示上传图 */
            thumbs.forEach(function (t) { t.classList.remove("is-active"); });
            firstThumb.classList.add("is-active");
            showMedia(firstImageIndex);
          }
        } else {
          if (mainImg && origMain) mainImg.src = origMain;
          if (firstThumb) {
            if (origThumbFull) firstThumb.setAttribute("data-full", origThumbFull);
            const ti = firstThumb.querySelector("img"); if (ti && origThumbImg) ti.src = origThumbImg;
          }
        }
      }
      function render() {
        syncHidden();
        previews.innerHTML = "";
        files.forEach(function (f, i) {
          const item = document.createElement("div");
          item.className = "parans-product__upload-thumb";
          if (/^image\//.test(f.type)) {
            const img = document.createElement("img");
            img.src = urlFor(f);
            item.appendChild(img);
          } else {
            const ext = document.createElement("span");
            ext.className = "parans-product__upload-ext";
            ext.textContent = ((f.name.split(".").pop()) || "FILE").toUpperCase().slice(0, 4);
            item.appendChild(ext);
          }
          const del = document.createElement("button");
          del.type = "button";
          del.className = "parans-product__upload-del";
          del.setAttribute("aria-label", "Remove file");
          del.innerHTML = "&times;";
          del.addEventListener("click", function (e) {
            e.preventDefault();
            files.splice(i, 1);
            render();
          });
          item.appendChild(del);
          const cap = document.createElement("span");
          cap.className = "parans-product__upload-fname";
          cap.textContent = f.name;
          item.appendChild(cap);
          previews.appendChild(item);
        });
        if (nameEl) nameEl.textContent = files.length ? (files.length + (files.length > 1 ? " files selected" : " file selected")) : original;
        syncGallery();
      }
      input.addEventListener("change", function () {
        if (input.files) { for (var i = 0; i < input.files.length; i++) files.push(input.files[i]); }
        input.value = "";   // 重置可见 input:同名文件可再选、避免重复计数
        render();
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-parans-product]").forEach(initProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();

/* ===== Custom Candy Keychain: Sequins line item property ===== */
(function () {
  var PRODUCT_PATH = "/products/custom-crystal-acrylic-charms";
  var IMAGE_URL = "https://parancrafts.com/cdn/shop/files/zhutulr-2.jpg?v=1743508464";
  var CARET = '<svg class="pp-ymqdd__caret" width="11" height="11" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function onProductPage() {
    return window.location.pathname.replace(/\/$/, "") === PRODUCT_PATH;
  }

  function injectStyle() {
    if (document.getElementById("pp-sequins-style")) return;
    var style = document.createElement("style");
    style.id = "pp-sequins-style";
    style.textContent = ".pp-sequins{order:82}.pp-sequins__head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:8px}.pp-sequins__head .parans-product__vlabel{margin:0}.pp-sequins__link{color:#000;text-decoration:underline;font-weight:600;white-space:nowrap}.pp-sequins .pp-ymqdd__opt{cursor:pointer}";
    document.head.appendChild(style);
  }

  function initSequins(root) {
    if (!onProductPage() || !(root instanceof HTMLElement)) return;
    var form = root.querySelector(".parans-product__form");
    if (!form || form.querySelector("[data-pp-sequins]")) return;
    injectStyle();

    var values = ["Please choose", "No Sequins", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18"];
    var field = document.createElement("div");
    field.className = "parans-product__field parans-product__vfield pp-sequins";
    field.setAttribute("data-pp-sequins", "");
    field.style.order = "82";

    var head = document.createElement("div");
    head.className = "pp-sequins__head";
    var label = document.createElement("span");
    label.className = "ymq_lable parans-product__vlabel";
    label.textContent = "Sequins";
    var link = document.createElement("a");
    link.className = "pp-sequins__link";
    link.href = IMAGE_URL;
    link.target = "_blank";
    link.rel = "noopener";
    link.textContent = "See Image";
    head.appendChild(label);
    head.appendChild(link);

    var hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "properties[Sequins]";
    hidden.value = "";
    hidden.disabled = true;

    var dd = document.createElement("div");
    dd.className = "pp-ymqdd pp-sequins__dd";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "pp-ymqdd__field";
    btn.setAttribute("aria-expanded", "false");
    var txt = document.createElement("span");
    txt.className = "pp-ymqdd__text";
    txt.textContent = values[0];
    btn.appendChild(txt);
    btn.insertAdjacentHTML("beforeend", CARET);

    var panel = document.createElement("div");
    panel.className = "pp-ymqdd__panel";
    values.forEach(function (val, i) {
      var opt = document.createElement("div");
      opt.className = "pp-ymqdd__opt";
      opt.textContent = val;
      opt.setAttribute("data-value", val);
      if (i === 0) opt.classList.add("is-active");
      opt.addEventListener("click", function () {
        txt.textContent = val;
        hidden.value = i === 0 ? "" : val;
        hidden.disabled = i === 0;
        panel.querySelectorAll(".pp-ymqdd__opt").forEach(function (item) { item.classList.remove("is-active"); });
        opt.classList.add("is-active");
        dd.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      });
      panel.appendChild(opt);
    });

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !dd.classList.contains("is-open");
      document.querySelectorAll(".pp-ymqdd.is-open").forEach(function (item) { item.classList.remove("is-open"); });
      dd.classList.toggle("is-open", willOpen);
      btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });

    dd.appendChild(btn);
    dd.appendChild(panel);
    field.appendChild(head);
    field.appendChild(hidden);
    field.appendChild(dd);

    var qtyLabel = form.querySelector(".parans-product__tier-label");
    form.insertBefore(field, qtyLabel || null);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-parans-product]").forEach(initSequins);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  setTimeout(initAll, 1200);
  setTimeout(initAll, 3000);
})();

/* ===== YMQ 按钮型选项 → 下拉框(设计 977-11961);不动 swatch(配件)===== */
(function () {
  function chevron() {
    return '<svg class="pp-ymqdd__caret" width="11" height="11" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function labelOf(r) {
    var it = r.closest(".ymq-option-value-item");
    var v = it && it.querySelector(".ymq-option-value");
    return v ? v.textContent.trim() : (r.value || "");
  }
  function transform(box) {
    if (box.querySelector(".pp-ymqdd")) return;                 // 已转换且还在
    if (!box.querySelector(".ymq-option-button-input")) return; // 只处理按钮型(跳过 swatch/image)
    var wrap = box.querySelector(".ymq-option-value-items");
    var radios = Array.prototype.slice.call(box.querySelectorAll(".ymq-option-button-input"));
    if (!wrap || !radios.length) return;

    var dd = document.createElement("div");
    dd.className = "pp-ymqdd";
    var field = document.createElement("button");
    field.type = "button";
    field.className = "pp-ymqdd__field";
    var txt = document.createElement("span");
    txt.className = "pp-ymqdd__text";
    field.appendChild(txt);
    field.insertAdjacentHTML("beforeend", chevron());
    var panel = document.createElement("div");
    panel.className = "pp-ymqdd__panel";

    function syncText() {
      var c = radios.filter(function (r) { return r.checked; })[0];
      txt.textContent = c ? labelOf(c) : (radios[0] ? labelOf(radios[0]) : "");
    }
    radios.forEach(function (r) {
      var opt = document.createElement("div");
      opt.className = "pp-ymqdd__opt";
      opt.textContent = labelOf(r);
      opt.addEventListener("click", function () {
        r.click();                 // 触发 YMQ 原生选中/计价逻辑
        syncText();
        dd.classList.remove("is-open");
      });
      r.addEventListener("change", syncText);
      panel.appendChild(opt);
    });
    var optionLabel = (box.querySelector(".ymq_lable")?.textContent || "").trim();
    var shouldSyncDefault = /\/products\/custom-acrylic-connection-keychains(?:\/|$)/i.test(window.location.pathname)
      && /^Acrylic \d+ Size$/i.test(optionLabel);
    if (shouldSyncDefault && !radios.some(function (r) { return r.checked; })) {
      var defaultRadio = radios.find(function (r) {
        return !r.disabled && !r.classList.contains("ymq-option-condtion-disabled");
      });
      if (defaultRadio) setTimeout(function () {
        if (!defaultRadio.isConnected || radios.some(function (r) { return r.checked; })) return;
        defaultRadio.checked = true;
        syncText();
        var productRoot = box.closest("[data-parans-product]");
        if (productRoot) productRoot.dispatchEvent(new CustomEvent("pp:variant-change"));
      }, 0);
    }
    syncText();
    field.addEventListener("click", function (e) {
      e.preventDefault();
      dd.classList.toggle("is-open");
    });
    dd.appendChild(field);
    dd.appendChild(panel);
    wrap.style.display = "none";
    wrap.parentNode.insertBefore(dd, wrap);
  }
  function getQty() {
    var qi = document.querySelector("[data-pp-qty] input") || document.querySelector("input[name='quantity']");
    var q = qi ? parseInt(qi.value, 10) : 0;
    return isNaN(q) ? 0 : q;
  }
  /* MOQ 提醒:默认隐藏;点"减少"或数量 < MOQ 时弹出展示 5 秒再自动收起(不依赖瞬时数量,避免 YMQ 把数量秒拉回 10 导致一闪而逝)*/
  var moqTimer = null, moqFlashing = false, moqFlashQty = null;
  function moqOf(ol) {
    if (!ol.dataset.ppMoq) {
      var m = (ol.textContent || "").match(/Minimum\s+(\d+)/i);
      if (m) ol.dataset.ppMoq = m[1];
    }
    return parseInt(ol.dataset.ppMoq, 10) || 0;
  }
  function updateMoqText(ol, qty) {
    var moq = moqOf(ol);
    if (!moq) return;
    var q = parseInt(qty, 10);
    if (isNaN(q)) q = getQty();
    var needed = Math.max(0, moq - q);
    var msg = "Minimum " + moq + " required. " + needed + " more needed.";
    var msgEl = ol.querySelector(".ymq-option-alert-msg");
    if (msgEl) {
      if (msgEl.textContent !== msg) msgEl.textContent = msg;
    } else if (ol.textContent !== msg) {
      ol.textContent = msg;
    }
  }
  function flashMoq(qty) {
    var ol = document.querySelector("ymq-option-order-limit");
    if (!ol || !moqOf(ol)) return;
    moqFlashQty = qty;
    updateMoqText(ol, qty);
    moqFlashing = true;
    ol.style.display = "block";
    if (moqTimer) clearTimeout(moqTimer);
    moqTimer = setTimeout(function () {
      moqFlashing = false;
      moqFlashQty = null;
      var o = document.querySelector("ymq-option-order-limit");
      if (o) o.style.display = "none";
    }, 5000);
  }
  function hideMoqDefault(ol) {
    ol = ol || document.querySelector("ymq-option-order-limit");
    if (!ol) return;
    if (ol.getAttribute("data-pp-moq-watch") !== "1") {
      ol.setAttribute("data-pp-moq-watch", "1");
      new MutationObserver(function () {
        if (moqFlashing) updateMoqText(ol, moqFlashQty);
        else hideMoqDefault(ol);
      }).observe(ol, {
        attributes: true,
        attributeFilter: ["style", "class"],
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    if (moqFlashing) {
      updateMoqText(ol, moqFlashQty);
      return;
    }
    updateMoqText(ol);
    if (!moqFlashing && ol.style.display !== "none") ol.style.display = "none";
  }
  function scan() {
    var anchor = document.querySelector("[data-pp-options-anchor]");
    if (anchor) {
      document.querySelectorAll("ymq-option").forEach(function (yo) {
        if (yo.closest(".ymq_modal__content") || yo.getAttribute("ymq-option-block-type") === "cart-edit") return;
        if (yo.parentElement !== anchor) anchor.appendChild(yo);
      });
    }
    // MOQ 提醒默认注入总额框,搬到 "Quantity" 标签正下方 + 按数量控制显隐/文案
    var ol = document.querySelector("ymq-option-order-limit");
    var label = document.querySelector(".parans-product__tier-label");
    if (ol && label && label.nextSibling !== ol) {
      label.parentNode.insertBefore(ol, label.nextSibling);
    }
    hideMoqDefault(ol);
    document.querySelectorAll(".ymq-options-box").forEach(transform);
  }
  /* 点"减少"且当前数量 ≤ MOQ(再减就违规)→ 弹 5 秒 */
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-pp-qty-dec]")) {
      var ol = document.querySelector("ymq-option-order-limit");
      var q = getQty();
      if (ol && moqOf(ol) && q <= moqOf(ol)) flashMoq(q - 1);
    }
  }, true);
  /* 手动把数量改到 < MOQ → 弹 5 秒 */
  document.addEventListener("input", function (e) {
    if (e.target && e.target.name === "quantity") {
      var ol = document.querySelector("ymq-option-order-limit");
      var q = parseInt(e.target.value, 10);
      if (ol && moqOf(ol) && q < moqOf(ol)) flashMoq(q);
    }
  });
  var pending = false;
  function schedule() {
    // YMQ briefly inserts its default MOQ alert during valid option changes.
    // Hide it in the same mutation cycle so it never reaches the next paint.
    hideMoqDefault();
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 200);
  }
  document.addEventListener("click", function (e) {
    document.querySelectorAll(".pp-ymqdd.is-open").forEach(function (dd) {
      if (!dd.contains(e.target)) dd.classList.remove("is-open");
    });
  });
  if (typeof MutationObserver !== "undefined" && document.body) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  setTimeout(scan, 1500);
  setTimeout(scan, 3000);
})();

/* ===== 自建 Shopify 变体选择器(2026-06)=====
   背景:YMQ 配 has_variant_option=false 时不显示 Shopify 原生变体(Size/Technique),
   导致前台选不了尺寸、价格锁死默认变体。这里读 liquid 吐出的变体数据,渲染成与站内一致的 pp-ymqdd 下拉;
   选了之后:① 改 data-pp-base=对应变体价 + 派发 pp:variant-change → 主题重算总价/单价/阶梯;
            ② 改 input[name=id]=变体 id 并派发 change → YMQ(keep_theme_variant)重算 + 加购带对的变体。
   关闭面板复用上面 pp-ymqdd 那段的全局 outside-click。 */
(function () {
  var CARET = '<svg class="pp-ymqdd__caret" width="11" height="11" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initVariants(root) {
    var dataEl = root.querySelector("[data-pp-variant-data]");
    var host = root.querySelector("[data-pp-variant-options]");
    var idInput = root.querySelector("input[name='id']");
    if (!dataEl || !host || !idInput || host.dataset.ppBuilt) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var options = data.options || [];
    var variants = (data.variants || []).filter(function (v) { return v && v.id; });
    var optNames = options.map(function (o) { return typeof o === "string" ? o : o.name; });
    if (!variants.length || !optNames.length) return;
    if (optNames.length === 1 && /^title$/i.test(optNames[0])) return; // 无真实变体

    function variantOptions(v) { return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); }

    var curId = parseInt(idInput.value, 10);
    var cur = variants.filter(function (v) { return v.id === curId; })[0]
           || variants.filter(function (v) { return v.available; })[0] || variants[0];
    var selected = variantOptions(cur).slice();

    function findVariant(sel) {
      return variants.filter(function (v) {
        var vo = variantOptions(v);
        return vo.length === sel.length && vo.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function valuesFor(oi) {
      var opt = typeof options[oi] === "object" ? options[oi] : null;
      if (opt && opt.values && opt.values.length) return opt.values;
      var set = []; variants.forEach(function (v) { var x = variantOptions(v)[oi]; if (x != null && set.indexOf(x) < 0) set.push(x); });
      return set;
    }
    function apply(silent) {
      var v = findVariant(selected);
      if (!v) return;
      root.setAttribute("data-pp-base", v.price);
      root.setAttribute("data-pp-variant-id", v.id);
      /* 0701 客户:切变体时同步"变体优惠划线原价"(compare_at,单位分)。compare_at>price 才显示 */
      var saleEl = root.querySelector("[data-pp-compare]");
      if (saleEl) {
        var ca = v.compare_at_price;
        if (ca && ca > v.price) { saleEl.textContent = "$" + (ca / 100).toFixed(2); saleEl.hidden = false; }
        else { saleEl.hidden = true; }
      }
      if (!silent) {
        idInput.value = String(v.id);
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      root.dispatchEvent(new CustomEvent("pp:variant-change"));
    }

    optNames.forEach(function (name, oi) {
      var values = valuesFor(oi);
      if (!values.length) return; // 0628:只跳过完全无值;单值选项(Materials/10pcs 等 Shopify 选项)也要渲染显示
      if (values.length <= 1 && /^title$/i.test(name)) return; // 跳过 Shopify 默认的单值 "Title" 占位

      var field = document.createElement("div");
      field.className = "parans-product__field parans-product__vfield";
      var lbl = document.createElement("span");
      lbl.className = "ymq_lable parans-product__vlabel"; lbl.textContent = name;
      field.appendChild(lbl);

      if (values.length === 1) {
        var single = document.createElement("div");
        single.className = "pp-variant-single";
        single.textContent = selected[oi] || values[0] || "";
        single.style.cssText = "min-height:45px;display:flex;align-items:center;padding:0 14px;border:1px solid #ddd;border-radius:8px;background:#fff;color:#000;";
        field.appendChild(single);
        host.appendChild(field);
        return;
      }

      var dd = document.createElement("div"); dd.className = "pp-ymqdd";
      var btn = document.createElement("button"); btn.type = "button"; btn.className = "pp-ymqdd__field";
      var txt = document.createElement("span"); txt.className = "pp-ymqdd__text"; txt.textContent = selected[oi];
      btn.appendChild(txt); btn.insertAdjacentHTML("beforeend", CARET);
      var panel = document.createElement("div"); panel.className = "pp-ymqdd__panel";

      values.forEach(function (val) {
        var opt = document.createElement("div"); opt.className = "pp-ymqdd__opt"; opt.textContent = val;
        if (val === selected[oi]) opt.classList.add("is-active");
        opt.addEventListener("click", function () {
          selected[oi] = val; txt.textContent = val;
          panel.querySelectorAll(".pp-ymqdd__opt").forEach(function (o) { o.classList.remove("is-active"); });
          opt.classList.add("is-active");
          dd.classList.remove("is-open");
          apply(false);
        });
        panel.appendChild(opt);
      });

      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var willOpen = !dd.classList.contains("is-open");
        document.querySelectorAll(".pp-ymqdd.is-open").forEach(function (d) { d.classList.remove("is-open"); });
        if (willOpen) dd.classList.add("is-open");
      });

      dd.appendChild(btn); dd.appendChild(panel); field.appendChild(dd);
      host.appendChild(field);
    });

    host.dataset.ppBuilt = "1";
    host.hidden = false;
    apply(true); // 初始静默对齐 base(不触发 YMQ change)
  }

  function initAll() { document.querySelectorAll("[data-parans-product]").forEach(initVariants); }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  setTimeout(initAll, 1200);   // 兜底:数据/DOM 异步就绪后再扫一次(已建则跳过)
})();

/* ===== 吸底购买条:主总额框滚出视口时浮出;吸底 ATC 触发主按钮(同一加购路径)=====
   价格/Save 同步由上面 recompute 的 setAll/hideAll 处理(复用同一组 data 属性)。 */
(function () {
  function initSticky(root) {
    var bar = root.querySelector("[data-pp-stickybuy]");
    var mainBox = root.querySelector("[data-pp-total-box]");
    if (!bar || !mainBox || bar.dataset.ppStickyInit) return;
    bar.dataset.ppStickyInit = "1";
    // 注:吸底条保留在产品区内(不移到 body)。之前移到 body 在用户浏览器上看不到了(zoom+fixed 组合问题),退回。
    // FAB 重叠已靠 justify-content:center(内容居中、不靠右)解决,不再需要移出。
    var mainAtc = root.querySelector("button[name='add']");
    var stickyAtc = bar.querySelector("[data-pp-stickybuy-atc]");
    if (stickyAtc && mainAtc) {
      var mainForm = mainAtc.closest("form");
      if (mainForm && mainForm.querySelector("ymq-option")) {
        // 保留吸底条原有定位,让用户直接点击第三方已绑定的原按钮；
        // form 属性维持原生表单关联,避免产品信息列的 transform 破坏 fixed 定位。
        var mainFormId = mainForm.getAttribute("id") || "parans-product-form";
        if (!mainForm.getAttribute("id")) mainForm.setAttribute("id", mainFormId);
        mainAtc.setAttribute("form", mainFormId);
        stickyAtc.replaceWith(mainAtc);
        mainAtc.classList.add("parans-product__stickybuy-atc");
        mainAtc.setAttribute("data-pp-stickybuy-atc", "");
        function hideDuplicateStickyUpload() {
          bar.querySelectorAll(".upload-container").forEach(function (upload) {
            upload.style.setProperty("display", "none", "important");
          });
          var wrapper = mainAtc.parentElement;
          if (wrapper && wrapper !== bar && wrapper.tagName === "SPAN" && bar.contains(wrapper)) {
            wrapper.style.setProperty("display", "contents", "important");
          }
          mainAtc.style.setProperty("white-space", "nowrap", "important");
          mainAtc.style.setProperty("width", "min(180px, 42vw)", "important");
          mainAtc.style.setProperty("flex", "0 0 min(180px, 42vw)", "important");
        }
        hideDuplicateStickyUpload();
        if (typeof MutationObserver !== "undefined") {
          new MutationObserver(hideDuplicateStickyUpload).observe(bar, { childList: true, subtree: true });
        }
      } else {
        stickyAtc.addEventListener("click", function () {
          if (mainForm && typeof mainForm.requestSubmit === "function") mainForm.requestSubmit(mainAtc);
          else mainAtc.click();
        });
        if (mainAtc.disabled) stickyAtc.setAttribute("disabled", "");
      }
    }
    // 原总额框被隐藏(如临时只用吸底条)时:吸底条常驻显示,不再依赖滚动观察
    if (getComputedStyle(mainBox).display === "none") { bar.hidden = false; return; }
    if (typeof IntersectionObserver === "undefined") return;   // 不支持就保持隐藏
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.hidden = e.isIntersecting; });   // 主框可见→收起;离开视口→浮出
    }, { threshold: 0, rootMargin: "0px 0px -40px 0px" });
    io.observe(mainBox);
  }
  function initAll() { document.querySelectorAll("[data-parans-product]").forEach(initSticky); }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  setTimeout(initAll, 1500);
})();

/* ============================================================
   0628 点9/10/11:产品选项按 CSS order 排序(纯 CSS、不挪 DOM → 永不复制、不破坏 YMQ)。
   表单已在 CSS 里设 flex + YMQ 外层 display:contents;这里按"标签优先级表"给每个选项设 style.order。
   全站一张表:每个产品只含其中一部分,相对顺序天然正确(钥匙扣/贴纸/徽章一张表通吃)。
   YMQ 切换变体重渲染后,MutationObserver 重设 order(只改 CSS 属性,幂等,绝不复制 DOM)。
   ============================================================ */
(function () {
  // 优先级:从具体到泛化。匹配 = 标签大写"包含" m 里任一关键词,取首个命中。
  var PRIORITY = [
    { m: ["DOUBLE SIDED PRINTING"], r: 10 },
    { m: ["MATERIAL"], r: 20 },                                   // Materials / MATERIALS
    { m: ["LAMINATION FILM"], r: 30 },
    { m: ["TECHNIQUE"], r: 40 },                                  // Additional Technique / Technique
    { m: ["ACRYLIC QUANTITY"], r: 45 },                            // 先选亚克力片数量,再按数量显示每片尺寸
    { m: ["SIZE"], r: 50 },
    { m: ["BACKPLATE"], r: 60 },
    { m: ["PURCHASE UNIT", "1 SET", "SET = 10", "STICKERS | MOQ"], r: 70 },   // 10pcs 套装组(多种命名)
    { m: ["ACCESSORY", "ACCESSORIES"], r: 80 },
    { m: ["QUANTITY", "QTY"], r: 90 },                            // 普通购买数量步进器(泛化,放 10pcs 之后)
    { m: ["UPLOAD"], r: 100 }
  ];
  function rankOf(label) {
    var L = (label || "").toUpperCase();
    for (var i = 0; i < PRIORITY.length; i++) {
      for (var j = 0; j < PRIORITY[i].m.length; j++) {
        if (L.indexOf(PRIORITY[i].m[j]) >= 0) return PRIORITY[i].r;
      }
    }
    return null;
  }
  function applyOrder(form) {
    if (!form) return;
    // 1) 自建块整块按其内"最小 rank"定位(内部选项本就连续、Shopify 顺序);无匹配兜底 45(不跳顶部)
    var vo = form.querySelector(".parans-product__variant-options");
    if (vo) {
      var min = 9999;
      vo.querySelectorAll(".parans-product__vlabel").forEach(function (l) {
        var r = rankOf(l.textContent); if (r != null && r < min) min = r;
      });
      vo.style.order = (min < 9999) ? min : 45;
    }
    // 2) YMQ 每个选项框各自标签 rank(Double Sided / Accessory 分别定位);无匹配兜底 85
    form.querySelectorAll("ymq-option .ymq-options-box").forEach(function (b) {
      var l = b.querySelector(".ymq_lable");
      var r = l ? rankOf(l.textContent) : null;
      b.style.order = (r != null) ? r : 85;
    });
    // 3) Quantity 标签 + 步进条(同 90,保持"标签在上")
    var qL = form.querySelector(".parans-product__tier-label"); if (qL) qL.style.order = 90;
    var qB = form.querySelector(".parans-product__tierbar"); if (qB) qB.style.order = 90;
    // 4) MOQ 提示跟 Quantity
    var ol = document.querySelector("ymq-option-order-limit"); if (ol) ol.style.order = 90;
    // 5) Upload 区
    form.querySelectorAll(".parans-product__field-label").forEach(function (lb) {
      if (/upload/i.test(lb.textContent)) {
        var f = lb.closest(".parans-product__field"); if (f) f.style.order = 100;
      }
    });
    var inlineAtc = form.querySelector("[data-pp-inline-atc]");
    if (inlineAtc) {
      var inlineAtcItem = inlineAtc;
      while (inlineAtcItem.parentElement && inlineAtcItem.parentElement !== form) {
        inlineAtcItem = inlineAtcItem.parentElement;
      }
      inlineAtcItem.style.order = 101;
      inlineAtc.style.order = 101;
    }
    var remarks = form.querySelector(".parans-product__remarks"); if (remarks) remarks.style.order = 102;
    var totalBox = form.querySelector("[data-pp-total-box]"); if (totalBox) totalBox.style.order = 110;
  }
  function initOrder() {
    var form = document.querySelector(".parans-product__form");
    if (!form) return;
    applyOrder(form);
    var n = 0, iv = setInterval(function () { n++; applyOrder(form); if (n > 40) clearInterval(iv); }, 300);
    var raf = null;
    var obs = new MutationObserver(function () {
      if (raf) return;                                            // 只观察 childList;改 order 不触发 → 不会自循环
      raf = requestAnimationFrame(function () { raf = null; applyOrder(form); });
    });
    obs.observe(form, { childList: true, subtree: true });
  }
  if (document.readyState !== "loading") initOrder();
  else document.addEventListener("DOMContentLoaded", initOrder);
  setTimeout(initOrder, 1500);
})();
